import { render, staticRenderFns } from "./LocationsOverview.vue?vue&type=template&id=64cb589c&scoped=true&"
import script from "./LocationsOverview.vue?vue&type=script&lang=js&"
export * from "./LocationsOverview.vue?vue&type=script&lang=js&"
import style0 from "./LocationsOverview.vue?vue&type=style&index=0&id=64cb589c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64cb589c",
  null
  
)

export default component.exports